
import axios from '@/utils/request'

export default {

  // 2021-09-23
  forEntity(entityName, entityId) {
    return axios.get('/logserver/core-logs?entityName=' + entityName + '&entityId=' + entityId)
  },
  // 2021-09-23
  forEntityMes(entityName, entityId) {
    return axios.get('/logserver/mes-logs?entityName=' + entityName + '&entityId=' + entityId)
  }
}

